/** @file RUNTIME_ERRORS: the error codes the Babylon runtime throws (bundle loading, sheets, harness). */

/** Error codes of runtime-babylon: bundle fetch and check, sheet decode, the headless Chromium harness. */
export const RUNTIME_ERRORS = {
  BUNDLE_FETCH: 'BUNDLE_FETCH', BUNDLE_INVALID: 'BUNDLE_INVALID', SHEET_MISSING: 'SHEET_MISSING',
  SHEET_SIZE_MISMATCH: 'SHEET_SIZE_MISMATCH', CHROMIUM_MISSING: 'CHROMIUM_MISSING',
} as const;
